import { locationGoogleMapStyles } from "@insite/content-library/Components/LocationGoogleMap";
import { GridOffset } from "@insite/mobius/GridContainer";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

Object.assign(locationGoogleMapStyles, {
    infoWindowGridContainer: {
        gap: 0,
        css: css`
            ${GridOffset} {
                width: 100% !important;
            }
        `,
    },
    currentLocationInfoWindowGridContainer: {
        gap: 0,
        css: css`
            ${GridOffset} {
                width: 100% !important;
            }
        `,
    },
    currentLocationInfoWindowSearchFilterGridItem: {
        css: css`
            display: none;
        `,
    },
});
